var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { fromSize } from '../../utilities/media';
import { Text } from '../Text';
import { StyledParagraph } from '../Markdown/components/Paragraph/styles';
export var AlertWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n  background: ", ";\n  border-radius: ", ";\n  padding: ", ";\n\n  ", " {\n    flex-flow: row nowrap;\n    align-items: flex-start;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n  background: ", ";\n  border-radius: ", ";\n  padding: ", ";\n\n  ", " {\n    flex-flow: row nowrap;\n    align-items: flex-start;\n  }\n"])), function (_a) {
  var theme = _a.theme,
    type = _a.type;
  return alertBgColor(type, theme);
}, function (_a) {
  var withoutBorder = _a.withoutBorder;
  return alertBorderRadius(withoutBorder);
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
}, fromSize('sm'));
export var AlertIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  margin-bottom: ", ";\n  flex-shrink: 0;\n\n  ", " {\n    margin-right: ", ";\n    margin-bottom: 0;\n  }\n"], ["\n  width: 24px;\n  height: 24px;\n  margin-bottom: ", ";\n  flex-shrink: 0;\n\n  ", " {\n    margin-right: ", ";\n    margin-bottom: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
}, fromSize('sm'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
});
export var AlertAction = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  margin-top: ", ";\n\n  ", " {\n    justify-content: flex-end;\n    margin-left: ", ";\n    margin-top: 0;\n  }\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  margin-top: ", ";\n\n  ", " {\n    justify-content: flex-end;\n    margin-left: ", ";\n    margin-top: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.sm;
}, fromSize('sm'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xl;
});
export var AlertContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 0;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex: 1 0;\n  flex-direction: column;\n"])));
export var Label = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n\n  ", ":first-child {\n    margin-top: 0;\n  }\n\n  ", ":last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  color: ", ";\n\n  ", ":first-child {\n    margin-top: 0;\n  }\n\n  ", ":last-child {\n    margin-bottom: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.onFeedback.lightest;
}, StyledParagraph, StyledParagraph);
export var Title = styled(Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  margin-bottom: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: ", ";\n"
// --- Helpers
])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.onFeedback.lightest;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing['2xs'];
});
// --- Helpers
var selectColor = {
  loading: 'info',
  error: 'negative',
  info: 'info',
  success: 'positive',
  warning: 'warning',
  tip: 'tip'
};
var alertBgColor = function (type, theme) {
  return selectColor[type] ? theme.tokens.interface.feedback[selectColor[type]].lightest : 'none';
};
var alertBorderRadius = function (withoutBorder) {
  return withoutBorder === 'both' ? '0' : withoutBorder === 'bottom' ? '4px 4px 0 0' : withoutBorder === 'top' ? '0 0 4px 4px' : '4px';
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;